import { Module, getModule, Action, Mutation } from "vuex-module-decorators";
import store from "@/store/VuexPlugin";
import { BaseStore } from "@/store/base.store";
import { FleetEventUIDto, IFleetEventUIDto } from "@/lib/dto/event/event-ui.dto";
import eventFleetService from "@/services/mrfiktiv/services/fleet/eventFleetService";
import { FleetEventDataAccessLayer } from "../access-layers/fleet-event.access-layer";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";

@Module({ dynamic: true, namespaced: true, name: "all-event-fleet", store })
class AllEventFleet extends BaseStore<IFleetEventUIDto> {
  _data = FleetEventDataAccessLayer;

  hiddenFilter = [];

  _dateRange: string[] = [
    new Date().toISOString(),
    new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString()
  ];

  filterOptions = FleetEventUIDto.filterables;

  get dateRange(): string[] {
    return this._dateRange;
  }

  @Mutation
  mutateExtendedFilters(filters: IPageFilterElement[]) {
    const lowerBoundDate = filters.find(
      (f) =>
        f.key === "startDate" &&
        [PageFilterOperationEnum.GREATER, PageFilterOperationEnum.GREATER_EQUAL].includes(
          f.operation as PageFilterOperationEnum
        )
    );
    if (lowerBoundDate) {
      this._dateRange.splice(0, 1, new Date(lowerBoundDate.value as string).toISOString());
    } else {
      filters.push(
        new PageFilterElement({
          key: "startDate",
          type: PageFilterTypes.DATE,
          operation: PageFilterOperationEnum.GREATER_EQUAL,
          value: this._dateRange[0].slice(0, 10)
        })
      );
    }

    const upperBoundDate = filters.find(
      (f) =>
        f.key === "startDate" &&
        [PageFilterOperationEnum.LESS, PageFilterOperationEnum.LESS_EQUAL].includes(
          f.operation as PageFilterOperationEnum
        )
    );
    if (upperBoundDate) {
      this._dateRange.splice(1, 1, new Date(upperBoundDate.value as string).toISOString());
    } else {
      filters.push(
        new PageFilterElement({
          key: "startDate",
          type: PageFilterTypes.DATE,
          operation: PageFilterOperationEnum.LESS_EQUAL,
          value: this._dateRange[1].slice(0, 10)
        })
      );
    }

    this.filters.splice(0, this.filters.length, ...filters);
  }

  @Action
  setFilters(filters: IPageFilterElement[]) {
    this.context.commit("mutateExtendedFilters", filters);
    return this;
  }

  @Action
  async fetchAll(data: { partnerId: string; fleetId: string; from?: number; to?: number }) {
    this.context.commit("mutateExtendedFilters", [...this.filters]);

    const from = data.from ?? new Date(this._dateRange[0]).getTime();
    const to = data.to ?? new Date(this._dateRange[1]).getTime();

    const events =
      (await eventFleetService.list({
        partnerId: data.partnerId,
        fleetId: data.fleetId,
        from,
        to
      })) ?? [];

    for (const event of events) {
      this._data.set(new FleetEventUIDto(event));
    }

    return events;
  }
}

export const AllEventFleetModule = getModule(AllEventFleet);
